module.exports = __webpack_public_path__ + "static/media/k_checklist.be71a6f0.svg";